export const pluralize = (string, predicate) =>
  predicate ? `${string}s` : string;
